import React, { useState } from 'react'
import { BlackCircle, Collapsable, Flex } from 'styling/GlobalStyles'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { CollapseItemText } from 'components/CollapseItem/CollapseItem.styled'
import Chevron from 'assets/icons/Chevron'
import { taskComponentTypes } from './taskData'
import { ICollapseItemDesignTask } from 'types/task-templates.interface'
import { ISelectValue } from 'constants/globalTypes'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { isMeasuredComponent, parseUnits } from 'features/units/unitsMappers'
import { COMPONENT_DIMENSION } from 'types/unitsEnums.interface'

export const CollapseItemDesignTask = ({
  data,
  setState,
}: ICollapseItemDesignTask) => {
  const [expanded, setExpanded] = useState(true)
  const handleRemove = () => {
    setState((prev) => {
      const copy = { ...prev }
      copy.components = copy.components.filter((item) => item.component !== data.component)
      return copy
    })
  }

  const handleSelect = (value: ISelectValue) => {
    setState((prev) => {
      const objIndex = prev.components.findIndex((obj) => obj.component == data.component)
      return {
        ...prev,
        components: prev.components.map((c, i) =>
          i === objIndex ? { ...c, componentType: value.value } : c,
        ),
      }
    })
  }

  const handleUnitSelect = (value: ISelectValue) => {
    setState((prev) => {
      const objIndex = prev.components.findIndex((obj) => obj.component == data.component)
      return {
        ...prev,
        components: prev.components.map((c, i) =>
          i === objIndex
            ? {
                ...c,
                unitId: value.value,
                unit: { id: value.value, name: value.label },
              }
            : c,
        ),
      }
    })
  }

  return (
    <Collapsable expanded={expanded}>
      <Flex mb='20'>
        <CollapseItemText expanded={expanded} onClick={() => setExpanded((prev) => !prev)}>
          {data.name} <Chevron gray />
        </CollapseItemText>
        <BlackCircle onClick={handleRemove}>
          <RemoveCircle white />
        </BlackCircle>
      </Flex>
      <HonestSelectInput
        width='100%'
        labelText='Field Type'
        options={taskComponentTypes}
        defaultValue={data.componentType}
        name='componentType'
        placeholder='Select here'
        onChange={handleSelect}
      />
      {isMeasuredComponent(data.component) && (
        <HonestSelectAsyncInput
          width='100%'
          labelText='Unit'
          name='unit'
          link='units'
          placeholder='Select unit'
          defaultValue={data.unit?.name}
          onChange={handleUnitSelect}
          parserFunction={(units: any) => parseUnits(units, COMPONENT_DIMENSION[data.component])}
        />
      )}
    </Collapsable>
  )
}
